export default {
  REACT_APP_API_URL: "https://powerdocx.com/v1",
  REACT_APP_API_BASE_URL: "https://powerdocx.com",
  STRIPE_PUBLIC_KEY: "pk_live_NGhWVZEJBn6ehWSSv7y0xjUs00jcfJWwxE",
};
